require('babel-polyfill');
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'regenerator-runtime/runtime';
import './assets/styles/styleCore.scss';
import bootstrap from './bootstrap';
import App from './containers/App';
import registerServiceWorker from './registerServiceWorker';
import { BugReporter } from '@lifesize/web-clients-core';
import { omit } from 'lodash';
import Filters from 'constants/Filters';

async function start() {
  const version = process.env.REACT_APP_VERSION || '0.0.1';
  console.info(`Dash Presenter v${version}`);
  const bugReporter = new BugReporter('f78e4f87c7c911be7a5584697ca8a5ad', version, window.lifesize.env);
  const store = await bootstrap();
  bugReporter.getState = () => omit(store.getState(), Filters.stateLog);
  const ErrorBoundary = bugReporter.getReactErrorBoundary(React);

  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>,
    document.getElementById('root')
  );
}

registerServiceWorker();
start();



// WEBPACK FOOTER //
// ./src/index.tsx